import { required } from 'vuelidate/lib/validators';

export default {
  companyName: { required },
  address: { required },
  phoneNumber: { required }
};
